<template>
  <AlertDialog v-model:open="isOpen">
    <AlertDialogTrigger>
      <slot />
    </AlertDialogTrigger>

    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>
          {{ t("settings.mcpServers.delete.title") }}
        </AlertDialogTitle>
        <AlertDialogDescription>
          <div class="space-y-2">
            <p>
              {{
                t("settings.mcpServers.delete.description", {
                  name: mcpServer?.name
                })
              }}
            </p>
          </div>
        </AlertDialogDescription>
      </AlertDialogHeader>

      <AlertDialogFooter>
        <AlertDialogCancel>
          {{ t("settings.mcpServers.delete.cancelButton") }}
        </AlertDialogCancel>
        <AlertDialogAction
          :disabled="isLoading"
          class="bg-red-600 hover:bg-red-700 focus:ring-red-600"
          @click="handleConfirm"
        >
          <LoadingIndicator v-if="isLoading" class="mr-2" />
          <Trash v-else name="delete" class="w-4 h-4 mr-2" />
          {{ t("settings.mcpServers.delete.confirmButton") }}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>

<script setup lang="ts">
import { Trash } from "lucide-vue-next";
import type { ApiMcpServer } from "~/server/api/organizations/[organizationId]/mcpServers/types";

interface Props {
  mcpServer: ApiMcpServer | null;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  confirmed: [mcpServer: ApiMcpServer];
}>();

const isOpen = ref(false);
const isLoading = ref(false);
const { t } = useI18n();

const handleConfirm = async () => {
  if (!props.mcpServer) return;

  isLoading.value = true;
  try {
    emit("confirmed", props.mcpServer);
  } finally {
    isLoading.value = false;
    isOpen.value = false;
  }
};

// Reset loading state when dialog closes
watch(isOpen, (newValue) => {
  if (!newValue) {
    isLoading.value = false;
  }
});
</script>
